import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Container,
  FormField,
  Header,
  Input,
  Multiselect,
  Select,
  SpaceBetween,
} from '@amzn/awsui-components-react';
import React from 'react';
import { get } from 'lodash';
import { bindActionCreators } from 'redux';
import getOptionsDefinition from './utils/util';
import { searchCostCentersQNQAction } from '../../../../qnq/components/cost_centers_tab/components/costs_table/redux/costCentersQnq';
import { updateSelectedSurveyType as updateSelectedSurveyTypeAction } from '../redux/selectedSurveyType';
import {
  getFormDataForSelectedSurveyType,
  getCombinedApplicableOptions,
  getSelectedSurveyType,
} from '../utils/selectors';

const DetailComponent = ({
  detailComponentState,
  setDetailComponentState,
  templateOptions,
  applicableToOptions,
  ccListOptions,
  recipientOptions,
  updateSelectedSurveyType,
}) => {
  return (
    <Container header={<Header variant="h2">Details</Header>}>
      <SpaceBetween size="l">
        <FormField label="Notification name">
          <Input
            value={detailComponentState.name}
            onChange={event =>
              setDetailComponentState(previousDetail => ({
                ...previousDetail,
                name: event.detail.value,
              }))
            }
          />
        </FormField>

        <FormField label="Applicable to">
          <Select
            options={applicableToOptions}
            selectedOption={detailComponentState.applicableTo}
            onChange={({ detail }) => {
              setDetailComponentState(previousDetail => ({
                ...previousDetail,
                applicableTo: detail.selectedOption,
              }));
              updateSelectedSurveyType(detail.selectedOption.value);
            }}
          />
        </FormField>

        <FormField label="Template" description="To add a new template, contact Taskless">
          <Select
            options={templateOptions}
            selectedOption={detailComponentState.template}
            onChange={({ detail }) =>
              setDetailComponentState(previousDetail => ({
                ...previousDetail,
                template: detail.selectedOption,
              }))
            }
          />
        </FormField>

        <FormField label="Recipient">
          <Select
            options={recipientOptions}
            selectedOption={detailComponentState.recipient}
            onChange={({ detail }) =>
              setDetailComponentState(previousDetail => ({
                ...previousDetail,
                recipient: detail.selectedOption,
              }))
            }
          />
        </FormField>

        <FormField
          label={
            <span>
              CC <i>- optional</i>{' '}
            </span>
          }
        >
          <Multiselect
            selectedOptions={detailComponentState.selectedCCList}
            onChange={({ detail }) =>
              setDetailComponentState(previousDetail => ({
                ...previousDetail,
                selectedCCList: detail.selectedOptions,
              }))
            }
            deselectAriaLabel={e => `Remove ${e.label}`}
            options={ccListOptions}
            placeholder="Choose options"
            selectedAriaLabel="Selected"
          />
        </FormField>
      </SpaceBetween>
    </Container>
  );
};

DetailComponent.propTypes = {
  detailComponentState: PropTypes.object.isRequired,
  setDetailComponentState: PropTypes.func.isRequired,
  templateOptions: PropTypes.array.isRequired,
  applicableToOptions: PropTypes.array.isRequired,
  ccListOptions: PropTypes.array.isRequired,
  recipientOptions: PropTypes.array.isRequired,
  updateSelectedSurveyType: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const selectedSurveyType = getSelectedSurveyType(state);

  const formData =
    ownProps.formDataCache && ownProps.formDataCache[selectedSurveyType]
      ? ownProps.formDataCache[selectedSurveyType]
      : getFormDataForSelectedSurveyType(state);

  const combinedApplicable = getCombinedApplicableOptions(state);

  return {
    templateOptions: getOptionsDefinition(get(formData, 'template', [])),
    applicableToOptions: getOptionsDefinition(combinedApplicable),
    ccListOptions: getOptionsDefinition(get(formData, 'ccList', []), selectedSurveyType),
    recipientOptions: getOptionsDefinition(get(formData, 'recipient', []), selectedSurveyType),
    applicableCCOperationOptions: getOptionsDefinition(
      get(formData, 'applicableCostCenterOperation', []),
    ),
    applicableFGBSVPOperationOptions: getOptionsDefinition(
      get(formData, 'applicableFGBSVPOperation', []),
    ),
    costCenterData: get(state, 'entities.qnq.costCenters.data', {}),
    isFetchingCostCenters: get(state, 'entities.qnq.costCenters.isFetching', false) || false,
    applicableEntitySectionOptions: getOptionsDefinition(
      get(formData, 'applicableEntitySection', []),
    ),
    entityId: get(state, 'entityId.entityId'),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      searchCostCenter: searchCostCentersQNQAction.BEGIN,
      updateSelectedSurveyType: updateSelectedSurveyTypeAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DetailComponent);
